<template>
  <div>
    <md-card v-for="conn in connections"
             :key="conn.uuid"
             class="cardsMargin margin-top-20">
      <md-card-header>
        <div class="md-title">
          <md-icon class="md-size-2x">{{enqIcons.connection.icon}}</md-icon>{{ $t('enquiriesPropertyDetails.SewerConn') }} {{conn.connNo}}
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout md-gutter md-dense">
          <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-100 md-xsmall-size-100">
            <md-field>
              <label>{{ $t('activities.connectionDate') }}</label>
              <md-input v-model="conn.connDateDisplay" readonly></md-input>
            </md-field>
          </div>
          
          <div class="md-layout-item md-xlarge-size-34 md-large-size-34 md-medium-size-34 md-small-size-100 md-xsmall-size-100">
            <md-field>
              <label>{{ $t('enquiries.statusDate') }}</label>
              <md-input v-model="conn.statusDateDisplay" readonly></md-input>
            </md-field>
          </div>
          
          <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-100 md-xsmall-size-100">
            <md-field>
              <label>{{ $t('enquiriesConnectionDetails.estimConsumption') }}</label>
              <md-input v-model="conn.estimConsump" readonly></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
  import enquiriesTools from '@/employee/enquiries/enquiriesTools';

  export default {
    name: 'customerDetails',
    components: {},
    mixins: [enquiriesTools],
    props: ['connections'],
    data: function () {
      return {}
    },    
    methods: {}
  }


</script>
<style src="./propertyDetails.css"></style>
